<homey-page-title title="Account"/>
<ul>
  @for (accountPageLink of accountPageLinks(); track accountPageLink) {
    <li>
      <app-account-page-link [accountPageLink]="accountPageLink"/>
    </li>
  }
</ul>

@if (user()) {
  <div class="text-center text-surface-500 mb-4">
    <p>Logged in as</p>
    <p>{{ email() }}</p>
  </div>
  <p-button (onClick)="logout()" styleClass="w-full" severity="contrast" label="Logout"/>
}
